import React, { useState, useEffect } from 'react';
import JsBarcode from 'jsbarcode';
import { createCanvas } from 'canvas';
import '../styles/armsform.css';

const GDSRForm = () => {
    const [formData, setFormData] = useState({
        token_id: 'E DSR(G) - ',
        dsr_no: '',
        date: '',
        subject: '',
        statement: '',
        sabotage: '',
        crime: '',
        politics: '',
        religious: '',
        strikes: '',
        incidents: '',
        recovery: '',
        miscellaneous: '',
        events: '',
        arrival: '',
        intelligence: '',
        raids: '',
        operation: '',
        narcotics: '',
        rains: '',
        copy_to: ''
    });

    const [message, setMessage] = useState(null);
    const [barcodeImage, setBarcodeImage] = useState(null);
    const [showPopup, setShowPopup] = useState(false);

    const generateBarcode = (tokenId) => {
        const canvas = createCanvas();
        JsBarcode(canvas, tokenId, { format: "CODE128" });
        return canvas.toDataURL("image/png");
    };

    useEffect(() => {
        if (formData.token_id) {
            const barcodeImage = generateBarcode(formData.token_id);
            setBarcodeImage(barcodeImage);
        } else {
            setBarcodeImage(null);
        }
    }, [formData.token_id]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.token_id || !formData.dsr_no || !formData.date) {
            setMessage("Please fill in the required fields: Token ID, DSR No, and Date.");
            return;
        }

        try {
            const response = await fetch('https://chaman.gob.pk/eac_backend/adddsr.php', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    action: 'add',
                    ...formData,
                    barcode: barcodeImage
                })
            });

            const result = await response.json();
            if (result.status === "success") {
                setMessage(result.message);
                setFormData({
                    token_id: '',
                    dsr_no: '',
                    date: '',
                    subject: '',
                    statement: '',
                    sabotage: '',
                    crime: '',
                    politics: '',
                    religious: '',
                    strikes: '',
                    incidents: '',
                    recovery: '',
                    miscellaneous: '',
                    events: '',
                    arrival: '',
                    intelligence: '',
                    raids: '',
                    operation: '',
                    narcotics: '',
                    rains: '',
                    copy_to: ''
                });
                setBarcodeImage(null);
                setShowPopup(true);
                setTimeout(() => setShowPopup(false), 2000);
            } else {
                setMessage("Error: " + result.message);
            }
        } catch (error) {
            console.error("Error submitting DSR form:", error);
            setMessage("An error occurred while submitting the form. Please try again.");
        }
    };

    return (
        <div className="lc-form-container">
            <form className="lc-form" onSubmit={handleSubmit}>
                <div className="lc-left-section">
                    <div className="lc-form-group">
                        <label className="lc-label">Token ID:</label>
                        <div className="lc-input-container">
                            <input 
                                type="text" 
                                name="token_id" 
                                value={formData.token_id} 
                                onChange={handleChange} 
                                className="lc-input"
                                required 
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">DSR No:</label>
                        <div className="lc-input-container">
                            <input 
                                type="text" 
                                name="dsr_no" 
                                value={formData.dsr_no} 
                                onChange={handleChange} 
                                className="lc-input"
                                required 
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Date:</label>
                        <div className="lc-input-container">
                            <input 
                                type="date" 
                                name="date" 
                                value={formData.date} 
                                onChange={handleChange} 
                                className="lc-input"
                                required 
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Subject:</label>
                        <div className="lc-input-container">
                            <input 
                                type="text" 
                                name="subject" 
                                value={formData.subject} 
                                onChange={handleChange} 
                                className="lc-input"
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Statement:</label>
                        <div className="lc-input-container">
                            <input 
                                type='text' 
                                name="statement" 
                                value={formData.statement} 
                                onChange={handleChange} 
                                className="lc-input"
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Sabotage:</label>
                        <div className="lc-input-container">
                            <input 
                                type="text" 
                                name="sabotage" 
                                value={formData.sabotage} 
                                onChange={handleChange} 
                                className="lc-input"
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Crime:</label>
                        <div className="lc-input-container">
                            <input 
                                type="text" 
                                name="crime" 
                                value={formData.crime} 
                                onChange={handleChange} 
                                className="lc-input"
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Politics:</label>
                        <div className="lc-input-container">
                            <input 
                                type="text" 
                                name="politics" 
                                value={formData.politics} 
                                onChange={handleChange} 
                                className="lc-input"
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Religious:</label>
                        <div className="lc-input-container">
                            <input 
                                type="text" 
                                name="religious" 
                                value={formData.religious} 
                                onChange={handleChange} 
                                className="lc-input"
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Strikes:</label>
                        <div className="lc-input-container">
                            <input 
                                type="text" 
                                name="strikes" 
                                value={formData.strikes} 
                                onChange={handleChange} 
                                className="lc-input"
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Incidents:</label>
                        <div className="lc-input-container">
                            <input 
                                type="text" 
                                name="incidents" 
                                value={formData.incidents} 
                                onChange={handleChange} 
                                className="lc-input"
                            />
                        </div>
                    </div>
                    <button type="submit" className="lc-submit-btn">Submit</button>
                </div>
                <div className="lc-right-section">
                    <div className="lc-form-group">
                        <label className="lc-label">Recovery:</label>
                        <div className="lc-input-container">
                            <input 
                                type="text" 
                                name="recovery" 
                                value={formData.recovery} 
                                onChange={handleChange} 
                                className="lc-input"
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Miscellaneous:</label>
                        <div className="lc-input-container">
                            <input 
                                type="text" 
                                name="miscellaneous" 
                                value={formData.miscellaneous} 
                                onChange={handleChange} 
                                className="lc-input"
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Events:</label>
                        <div className="lc-input-container">
                            <input 
                                type="text" 
                                name="events" 
                                value={formData.events} 
                                onChange={handleChange} 
                                className="lc-input"
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Arrival:</label>
                        <div className="lc-input-container">
                            <input 
                                type="text" 
                                name="arrival" 
                                value={formData.arrival} 
                                onChange={handleChange} 
                                className="lc-input"
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Intelligence:</label>
                        <div className="lc-input-container">
                            <input 
                                type="text" 
                                name="intelligence" 
                                value={formData.intelligence} 
                                onChange={handleChange} 
                                className="lc-input"
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Raids:</label>
                        <div className="lc-input-container">
                            <input 
                                type="text" 
                                name="raids" 
                                value={formData.raids} 
                                onChange={handleChange} 
                                className="lc-input"
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Operation:</label>
                        <div className="lc-input-container">
                            <input 
                                type="text" 
                                name="operation" 
                                value={formData.operation} 
                                onChange={handleChange} 
                                className="lc-input"
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Narcotics:</label>
                        <div className="lc-input-container">
                            <input 
                                type="text" 
                                name="narcotics" 
                                value={formData.narcotics} 
                                onChange={handleChange} 
                                className="lc-input"
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Rains:</label>
                        <div className="lc-input-container">
                            <input 
                                type="text" 
                                name="rains" 
                                value={formData.rains} 
                                onChange={handleChange} 
                                className="lc-input"
                            />
                        </div>
                    </div>
                    <div className="lc-form-group">
                        <label className="lc-label">Copy To:</label>
                        <div className="lc-input-container">
                            <textarea 
                                name="copy_to" 
                                value={formData.copy_to} 
                                onChange={handleChange} 
                                className="lc-input"
                                style={{ borderRadius: '6px', minHeight: '100px' }}
                            />
                        </div>
                    </div>
                </div>
            </form>

            {/* {barcodeImage && (
                <div className="lc-barcode-container">
                    <img src={barcodeImage} alt="Barcode" className="lc-barcode" />
                </div>
            )} */}

            {showPopup && (
                <div className="lc-popup">
                    Data saved successfully!
                </div>
            )}
        </div>
    );
};

export default GDSRForm;